import { Loader } from "@circle-react-uikit/Loader";
import { VideoJSPlayer } from "../../Room/HlsPlayer/VideoJSPlayer";
import { usePublicLiveStore } from "../store";
import { FullscreenButton } from "./FullscreenButton";
import { useFullscreenBehavior } from "./hooks/usePlayerFullscreenBehavior";

interface PlayerProps {
  hlsUrl: string | undefined;
}

export const Player = ({ hlsUrl }: PlayerProps) => {
  const { isGuestPromptOpen } = usePublicLiveStore();
  const shouldDisplayLoader = !hlsUrl || isGuestPromptOpen;
  const { elementRef, toggleFullscreen, isFullscreen } =
    useFullscreenBehavior();

  return (
    <div
      ref={elementRef}
      className="group relative h-full w-full"
      onDoubleClick={toggleFullscreen}
    >
      {!shouldDisplayLoader && (
        <>
          <div className="opacity-0 transition-opacity group-hover:opacity-100">
            <FullscreenButton
              onClick={toggleFullscreen}
              isFullscreen={isFullscreen}
            />
          </div>
          <VideoJSPlayer hlsUrl={hlsUrl} />
        </>
      )}
      {shouldDisplayLoader && (
        <Loader className="absolute flex h-full w-full justify-center align-middle" />
      )}
    </div>
  );
};
